import { createSelector } from '@reduxjs/toolkit';

import getMediaElementsByUuids from 'editor/src/store/design/selector/getMediaElementsByUuids';
import { areAllTextElements } from 'editor/src/store/design/util/elementTypeGuards';

import { RootState } from 'editor/src/store';

import { FontStyles } from '../types';
import extractTextElementFontStyles from '../utils/extractTextElementFontStyles';

const createFontStyleSelector = <T extends keyof FontStyles>(key: T) =>
  createSelector(
    [(state: RootState) => state.editor.selectedElementUuids, (state: RootState) => state],
    (selectedElementUuids, state): FontStyles[T][] => {
      const selectedElements = getMediaElementsByUuids(state, selectedElementUuids);

      if (!areAllTextElements(selectedElements) || selectedElements.length === 0) {
        return [];
      }

      const elementStyles = selectedElements.map(extractTextElementFontStyles);
      return elementStyles.map((style) => style[key]);
    },
  );

export const getSharedFontStyles = createFontStyleSelector;
export const getSharedFontSize = createFontStyleSelector('fontSize');

export default getSharedFontStyles;
